import { SvgIcon, SvgIconProps } from "@mui/material";

export const CreateNewChatIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        d="M17.4999 17.4999H10.8333M2.08325 17.9166L6.70764 16.138C7.00343 16.0242 7.15132 15.9673 7.28968 15.8931C7.41259 15.8271 7.52975 15.751 7.63995 15.6654C7.76402 15.5692 7.87606 15.4571 8.10015 15.233L17.4999 5.83326C18.4204 4.91279 18.4204 3.4204 17.4999 2.49993C16.5795 1.57945 15.0871 1.57945 14.1666 2.49992L4.76682 11.8997C4.54273 12.1238 4.43069 12.2358 4.33441 12.3599C4.2489 12.4701 4.17275 12.5873 4.10678 12.7102C4.03251 12.8485 3.97563 12.9964 3.86186 13.2922L2.08325 17.9166ZM2.08325 17.9166L3.79835 13.4574C3.92108 13.1383 3.98245 12.9787 4.0877 12.9057C4.17969 12.8418 4.2935 12.8176 4.4035 12.8386C4.52936 12.8627 4.65024 12.9836 4.89199 13.2253L6.77456 15.1079C7.01631 15.3496 7.13719 15.4705 7.16122 15.5964C7.18223 15.7064 7.15807 15.8202 7.09421 15.9122C7.02112 16.0174 6.86158 16.0788 6.54248 16.2015L2.08325 17.9166Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </SvgIcon>
  );
};

export const SearchIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} width="18" height="19" viewBox="0 0 18 19" fill="none">
      <path
        d="M15.75 16.25L13.1251 13.625M15 9.125C15 12.6458 12.1458 15.5 8.625 15.5C5.10418 15.5 2.25 12.6458 2.25 9.125C2.25 5.60418 5.10418 2.75 8.625 2.75C12.1458 2.75 15 5.60418 15 9.125Z"
        stroke="#A0A0A0"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </SvgIcon>
  );
};

export const OnlineIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 4 4" fill="none">
      <circle cx="2" cy="2" r="2" fill="#12B76A" />
    </SvgIcon>
  );
};

export const SendButtonIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} width="17" height="16" viewBox="0 0 17 16" fill="none">
      <path
        d="M13.7133 0.600916L1.77067 4.94683C1.48824 5.04887 1.25596 5.25602 1.12213 5.52503C0.988398 5.79415 0.963435 6.10441 1.05247 6.39138C1.1415 6.67834 1.33776 6.91998 1.60035 7.0659L6.63608 9.86367L9.43263 14.8982C9.53272 15.0816 9.68072 15.2344 9.8608 15.3404C10.0408 15.4463 10.2462 15.5015 10.455 15.5H10.5454C10.7691 15.4834 10.9831 15.4023 11.1616 15.2664C11.34 15.1306 11.4753 14.9458 11.5508 14.7346L15.8948 2.78338C16.042 2.37525 16.0281 1.92632 15.8559 1.52817C15.6837 1.12989 15.3663 0.812361 14.9682 0.640046C14.5702 0.467848 14.1215 0.453932 13.7135 0.60116L13.7133 0.600916ZM14.5347 1.96485C14.6285 2.05654 14.6592 2.19496 14.6131 2.3177L10.4157 13.8615L7.98896 9.48001L11.3683 6.09248C11.5265 5.9179 11.5834 5.67399 11.5187 5.44734C11.454 5.22079 11.2769 5.04358 11.0505 4.97889C10.8239 4.9142 10.5801 4.97104 10.4056 5.12933L7.01953 8.51016L2.63989 6.08235L14.1803 1.88318C14.3038 1.83573 14.4436 1.86736 14.5347 1.96333L14.5347 1.96485Z"
        fill="white"
        stroke="white"
        strokeWidth="0.2"
      />
    </SvgIcon>
  );
};
